/* eslint-disable @typescript-eslint/no-unused-vars */
import { Input } from "antd";
import { InstructionCard } from "../../../components";
import { useState, useEffect, useMemo } from "react";
import {
  EnterVisaInfoGuide,
  ForeignerObligation,
  PassportCannotIssued,
  PayingGuide,
  ProcedureForInviting,
  SearchApplicationGuide,
  TemporaryResidence,
  VerifyVisaInfoGuide,
} from "./Contents";
import { useTranslation } from "react-i18next";

interface IInstruction {
  title: string;
  content: any;
}

const InstructionPage = () => {
  const { t } = useTranslation();

  const mockInstructionsData: IInstruction[] = useMemo(
    () => [
      {
        title: t("instructions.instructions_list.enter_info_guide.title"),
        content: <EnterVisaInfoGuide />,
      },
      {
        title: t("instructions.instructions_list.verify_info_guide.title"),
        content: <VerifyVisaInfoGuide />,
      },
      {
        title: t("instructions.instructions_list.paying_guide.title"),
        content: <PayingGuide />,
      },
      {
        title: t(
          "instructions.instructions_list.search_application_guide.title"
        ),
        content: <SearchApplicationGuide />,
      },
      {
        title: t("instructions.instructions_list.procedure_for_inviting.title"),
        content: <ProcedureForInviting />,
      },
      {
        title: t("instructions.instructions_list.temporary_residence.title"),
        content: <TemporaryResidence />,
      },
      {
        title: t("instructions.instructions_list.foreigner_obligation.title"),
        content: <ForeignerObligation />,
      },
      {
        title: t("instructions.instructions_list.passport_cannot_issued.title"),
        content: <PassportCannotIssued />,
      },
    ],
    [t]
  );

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredInstructions, setFilteredInstructions] =
    useState(mockInstructionsData);

  const handleSearch = (value: string) => {
    setSearchQuery(value);
  };

  useEffect(() => {
    const filtered = mockInstructionsData.filter((instruction) =>
      instruction.title.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredInstructions(filtered);
  }, [mockInstructionsData, searchQuery]);

  return (
    <div>
      <div className="w-full py-8 px-4 text-center text-white bg-gradient-to-b from-[#F00D0D] to-[#994F4F]">
        <h1 className="text-[32px] font-bold mb-2">
          {t("instructions.title")}
        </h1>
        <p className="text-[22px] font-bold">{t("instructions.subtitle")}</p>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-20 flex flex-col justify-center items-center gap-10">
        <InstructionSearchBar t={t} onSearch={handleSearch} />

        {filteredInstructions.length === 0 ? (
          <p className="text-center text-lg text-gray-500">
            No instructions found
          </p>
        ) : (
          <div className="w-full flex flex-col gap-6">
            {filteredInstructions.map((instruction, index) => (
              <InstructionCard
                key={index}
                title={instruction.title}
                content={instruction.content}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default InstructionPage;

const InstructionSearchBar = ({
  t,
  onSearch,
}: {
  t: any;
  onSearch: (value: string) => void;
}) => {
  return (
    <div className="w-full max-w-5xl mb-10">
      <Input.Search
        placeholder={t("instructions.search_hint")}
        enterButton
        size="large"
        onSearch={onSearch}
      />
    </div>
  );
};
